import React, { useEffect, useState } from 'react'
import { getInitials } from '../../../utils/commonServices'
import { Avatar, Box, Collapse, IconButton, ListItemText, Menu, MenuList, Typography } from '@mui/material'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { MenuItem } from '@mui/material';
import CheckRoundedIcon from '@mui/icons-material/CheckRounded';
import { useDispatch, useSelector } from 'react-redux';
import { updateTeamState } from '../../../redux/teamSlice';
import { useLocation, useNavigate } from 'react-router-dom';
import { updateOrganisationMemberRole } from '../actions';
import usePermissions from '../../../hooks/usePermissions';
import { PERMISSION } from '../../../constants/constants';
import { colors } from '../../../constants/staticData';
// import { customTheme as theme } from '../../../theme/customTheme';
import useCustomTheme from '../../../theme/useCustomTheme';
import useDashboardActions from '../useDashboardActions';
import { updateState } from '../../../redux/commonSlice';

let counter = 0;

const OrganisationMembersList = ({member, index, searchedArray, setTestmembers, roleOptions}) => {

    const [anchorEl, setAnchorEl] = useState(null);
    const [selectedRole, setSelectedRole] = useState(member?.role_name);
    const commonReducer = useSelector((state) => state.root.commonReducer);
    const teamsReducer = useSelector((state) => state.root.teamsReducer);
    const dropdownReducer = useSelector((state) => state.root.dropdownReducer);
    const permissionsReducer = useSelector((state) => state.permissionsReducer)
    const dispatch = useDispatch()
    const location = useLocation()
    const navigate = useNavigate()
    const [hasPermission] = usePermissions()
    const [theme ] = useCustomTheme()
    const {updateOrganisationMemberRole, removeOrganisationMember} = useDashboardActions()

    // console.log({member})

    const [numberOfAdmins, setNumberOfAdmins] = useState(searchedArray.filter(member => member?.role_name == 'Admin').length)

    // useEffect(()=>{
    //   dispatch(updateTeamState({selected_member: member}))
    // },[member])

    console.log(member)

     useEffect(()=>{
       setSelectedRole(member.role_name)
     },[member.role_name, member])

  
    useEffect(()=>{
         setNumberOfAdmins(commonReducer.organisation_members_list?.filter((item) => item.role_name == 'Admin').length)  
    },[searchedArray,commonReducer.organisation_members_list ])
  
    // console.log({searchedArray}, 'members page')
    // console.log(teamsReducer.organization_members , 'members page')
    // console.log('no of admins', numberOfAdmins)
    // console.log('selected role', selectedRole)
  
    const open = Boolean(anchorEl);

    const handleClick = (event) => {
        event.stopPropagation()
        setAnchorEl(event.currentTarget);
    };

    const handleClose = (e) => {
        e.stopPropagation();
        setAnchorEl(null);
    };
  
    const handleRoleSelect = (role, member) => {  
        if ( member?.role_name == 'Admin'){
          if(numberOfAdmins === 1) {
            dispatch(updateTeamState({assign_role_popup : true, change_admin_flag: true, invite_team_members_popup : false}))
          } else {
            dispatch(updateTeamState({selected_member: member, selected_role: role}))
            dispatch(updateState({change_member_role_confirmation_popup: true, invite_org_members_popup: false, change_member_role_existing_role: "Admin" })) 
          }
        
        }else{
          dispatch(updateTeamState({selected_member: member, selected_role: role}))
          dispatch(updateState({change_member_role_confirmation_popup: true, invite_org_members_popup: false, change_member_role_existing_role: "Editor" }))
        // const payload = {
        //     id: member?.id,
        //     role_id: role?.id
        // }
        // updateOrganisationMemberRole(payload)
        // setSelectedRole(role.name);
       }
      setAnchorEl(null);
    };

    const handleDeleteMember =()=>{ 
        if(member.role_name == 'Admin'){
          if (numberOfAdmins == 1) {
            dispatch(updateTeamState({assign_role_popup : true}))
          } else {
            dispatch(updateTeamState({selected_member: member}))
            dispatch(updateTeamState({remove_member_confirmation_popup : true}))
          }
        }else{
          dispatch(updateTeamState({selected_member: member}))
          dispatch(updateTeamState({remove_member_confirmation_popup : true}))
        }
      dispatch(updateTeamState({invite_team_members_popup : false}))   
      setAnchorEl(null);
    }
  
   // Determine current user's role
   const currentUserIsAdmin = commonReducer?.role_name === 'Admin';
   const currentUserIsQC = commonReducer?.role_name === 'QC';
   const currentUserIsEditor = commonReducer?.role_name === 'Editor';
   
   // Determine if member is an Admin or is the super admin (protected from changes)
   const memberIsAdmin = member?.role_name === 'Admin';
   const memberIsSuperAdmin = member?.super_admin === true;
   
   // Determine if dropdown should be shown
   // Super admin cannot be modified by anyone
   // Admin can change anyone's role (except super admin)
   // QC can only view, cannot change roles
   // Editor cannot change anyone
   const shouldShowDropdown = commonReducer.invite_org_members_popup && !memberIsSuperAdmin && (
     currentUserIsAdmin // Only Admin can change anyone's role (except super admin)
     // QC and Editor cannot change anyone (no condition for them)
   );

  return (
    <div style={{width:{xs:'90%', md:'80%'}, marginTop:'12px'}}>
        {searchedArray?.length > 0 &&
            <>
            <Box mb={1} className='flex a-center' gap={2}>
    
                                <Avatar
                                    sx={{
                                    borderRadius: '5px',
                                     backgroundColor: colors[index % colors.length],
                                   // backgroundColor: color,
                                    color: 'white',
                                    width: { xs: '18px', sm: '20px', md: '22px', lg: '23.5px', xl: '35px' },
                                    height: { xs: '18px', sm: '20px', md: '22px', lg: '23.5px', xl: '35px' },
                                    paddingRight: 0,
                                    marginRight: 0,
                                    fontSize: { xs: '7px', md: '8px', lg: '8px', xl: '12px' },
                                    textTransform: 'uppercase',
                                    fontFamily: 'Rubik',
                                    fontWeight:600
                                    }}
                                >
                                    {getInitials(member.name)}
                                </Avatar>
                <Box flex={8} className='flex col' sx={{fontSize:{xs:'9px', md:'10px',lg:'13px', xl:'18px'}, fontWeight:600, fontFamily:'Rubik', color:'#000000'}}>
                   {member.name}
                    <br />
                    <Box component='span' sx={{fontSize:{xs:'9px', md:'10px',lg:'11px', xl:'13.5px'}, fontWeight:500}}>{member.email}</Box>
                </Box>
             <Box flex={6} className='flex a-center' style={{justifyContent:'end'}}>
                    <Typography sx={{ fontSize: {xs:'9px', md:'10px',lg:'12px', xl:'16px'}, fontWeight: 500, color:'#000000', fontFamily:'Rubik'}}>
                        {/* { selectedRole || member.role.name} */}
                        {member?.role_name}
                    </Typography>
                {shouldShowDropdown && 
                    <IconButton edge="end" disabled = {teamsReducer.is_loading}  onClick={handleClick}>
                        <ExpandMoreIcon  sx={{ fontSize: {xs:'10px', md:'12px',lg:'14px', xl:'16px'} }} />
                    </IconButton>
                }
                </Box>
            </Box>
     
            </>}
    

         <Menu
            id="role-menu"
            anchorEl={anchorEl}
            open={open}
            onClose={handleClose}
            MenuListProps={{
                "aria-labelledby": "basic-button",
            }}
            anchorOrigin={{
                vertical: "bottom",
                horizontal: "right",
            }}
            transformOrigin={{
               
                vertical: 0,
                horizontal: 150
            }}
          >
          {/* {hasPermission(PERMISSION.ORGANISATION.MEMBER.UPDATE) &&  roleOptions?.map((role, index) => (
              <MenuItem key={index} onClick={() => handleRoleSelect(role, member)} sx={{'&:hover':{backgroundColor:`${theme.palette.primary.main}70`, color:'black'}, backgroundColor: selectedRole == role.name && `${theme.palette.primary.main}99`}}>
                <ListItemText><Typography sx={{ fontFamily: 'Rubik', fontSize: { xs: '8px', md: '10px', lg: '11px', xl: '13px', fontWeight: 600, color: '#000000' } }}>Set as {role.name}</Typography></ListItemText>
                {selectedRole == role.name && <CheckRoundedIcon style={{fontSize:'10px', fontWeight:600}}/>}
              </MenuItem>
            ))}
           {hasPermission(PERMISSION.ORGANISATION.MEMBER.DELETE) &&   <MenuItem onClick={() => handleDeleteMember()} sx={{'&:hover':{backgroundColor:`${theme.palette.primary.main}70`, color:'black'}}}>
                <ListItemText><Typography sx={{ fontFamily: 'Rubik', fontSize: { xs: '8px', md: '10px', lg: '11px', xl: '13px', fontWeight: 600, color: '#CE0101' } }}>Remove from Organization</Typography></ListItemText>
            </MenuItem>} */}

            {roleOptions?.map((role, index) => {
              // QC users cannot assign Admin role
              const isDisabled = currentUserIsQC && role.name === 'Admin';
              
              return (
                <MenuItem 
                  key={index} 
                  onClick={() => handleRoleSelect(role, member)} 
                  disabled={isDisabled}
                  sx={{
                    '&:hover':{backgroundColor:`${theme.palette.primary.main}70`, color:'black'}, 
                    backgroundColor: selectedRole == role.name && `${theme.palette.primary.main}99`,
                    opacity: isDisabled ? 0.5 : 1,
                    cursor: isDisabled ? 'not-allowed' : 'pointer'
                  }}
                >
                  <ListItemText><Typography sx={{ fontFamily: 'Rubik', fontSize: { xs: '8px', md: '10px', lg: '11px', xl: '13px', fontWeight: 600, color: '#000000' } }}>Set as {role.name}</Typography></ListItemText>
                  {selectedRole == role.name && <CheckRoundedIcon style={{fontSize:'10px', fontWeight:600}}/>}
                </MenuItem>
              );
            })}
            <MenuItem onClick={() => handleDeleteMember()} sx={{'&:hover':{backgroundColor:`${theme.palette.primary.main}70`, color:'black'}}}>
                <ListItemText><Typography sx={{ fontFamily: 'Rubik', fontSize: { xs: '8px', md: '10px', lg: '11px', xl: '13px', fontWeight: 600, color: '#CE0101' } }}>Remove member</Typography></ListItemText>
            </MenuItem>
     
        </Menu> 
    </div>
  )
}

export default OrganisationMembersList